"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Teams = exports.TeamsSlugs = void 0;
const teams_1 = require("./teams");
Object.defineProperty(exports, "Teams", { enumerable: true, get: function () { return teams_1.Teams; } });
Object.defineProperty(exports, "TeamsSlugs", { enumerable: true, get: function () { return teams_1.TeamsSlugs; } });
//# sourceMappingURL=index.js.map